module.exports = __webpack_public_path__ + "img/ag.b8bd8a99.jpg";